<template>
  <div class="wrapper">
    <div class="icon">
      <v-avatar size="60">
        <img v-if="currentImage" :src="currentImage" :alt="initials" class="primary" />
        <v-avatar v-else color="primary" size="60">
          <span class="white--text">{{ initials }}</span>
        </v-avatar>
      </v-avatar>
    </div>

    <div class="content">
      <div class="name subheading">
        {{ employee.firstname }} {{ employee.lastname }}<br />
        <div class="grey--text">
          {{ `${position ? position : ''}${position && department ? ', ' : ''}${department ? department : ''}` }}
        </div>
      </div>

      <div class="tags-container">
        <div class="tags-inner-container">
          <v-chip color="accent" class="tag" v-for="tag in tags" :key="tag">{{ tag }}</v-chip>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import index from './index';
import common from '@/mixins/common';
import employeeService from '@/modules/employee/employeeService';
import {mapState} from "vuex";

export default {
  name: 'EmployeeRow',
  methods: {},
  mixins: [common],

  props: {
    employee: Object,
    photoFilename: String,
  },
  computed: {
    ...mapState({ isConnected: (state) => state.isConnected, }),
    tags() {
      return this.employee.tags ? this.employee.tags : [];
    },
    person() {
      return this.employee;
    },

    position() {
      return this.employee.position;
    },
    department() {
      return this.employee.department;
    },

    fileUrl() {
      let fileName = this.photoFilename;
      let fileUrl;
      if (fileName) {
        fileUrl = this.moduleFileUrl(index.moduleId, fileName);
      }
      return fileUrl;
    },
    currentImage() {
      if (this.fileUrl && this.isConnected) return this.fileUrl;
      return null;
    },
    initials() {
      return employeeService.getInitials(this.person);
    },
  },
};
</script>

<style scoped>
.wrapper {
  column-gap: 10px;
  display: flex;
  height: 100%;
  flex-wrap: nowrap;
  padding: 10px 0;
  row-gap: 20px;
  margin:10px;
  border-radius:10px
}
.theme--dark .wrapper{
  border:1px solid #606060
}
.theme--light .wrapper{
  border:1px solid #e0e0e0
}

.content {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
  align-items: center;
  overflow: visible;
  padding: 10px;
}

.tags-container {
  display: flex;
  flex-wrap: wrap;
  align-self: center;
  flex: 1;
  gap: 5px;
  height: 100%;
  overflow-y: scroll;
  padding-right: 5px;
}

.tags-inner-container {
  display: flex;
  flex-wrap: wrap;
}

.tag {
  margin: 1px;
}

.icon {
  display: flex;
  row-gap: 20px;
  min-width: 60px;
  align-self: center;
  padding-left: 10px;
}

.name {
  align-self: center;
  min-width: 300px;
}

/* sm - small */
@media screen and (max-width: 600px) {
  .name {
    width: 100%;
  }

  .tags-container {
    height: 100%;
    flex-wrap: nowrap;
    overflow-y: hidden;
    overflow-x: scroll;
    padding-right: 20px;
  }

  .tags-inner-container {
    display: flex;
    flex-wrap: nowrap;
    overflow-y: unset;
    padding-right: 55px;
  }
}
</style>
